<template>
  <div>
    <div class="testImg" :style="{ background: `url(${image})` }"></div>

    <BaseHeadline
      :showOnMobile="true"
      icon="mdi-information-variant"
      :headerName="project.name"
      :subtitle="project.projTypeName"
      :showFolowing="isTrysilhus"
      :isFollowed="project.isFavourite"
      :enableFollowing="getFollowingEnable"
      @toggelFollowing="updateFavourite(project)"
      @clickIcon="projectInfo"
    >
      <template v-slot:headlineBtns>
        <v-btn icon large @click="getAccident">
          <v-img
            max-height="45"
            max-width="40"
            src="@/assets/icons/Ulykke.svg"
          ></v-img>
        </v-btn>
      </template>
    </BaseHeadline>

    <v-alert
      v-if="
        !psiAccepted && (project.isPsiMissing === false || project.hasInfotech)
      "
      border="left"
      color="info"
    >
      <v-row align="center">
        <v-col class="grow">
          <span v-if="noHMScard">
            HMS-kort er ikke lagt til! Gå til "Min profil" for å legge til!
          </span>
          <span v-else> Personlig sikkerhetsinstruks er ikke godkjent! </span>
        </v-col>
        <v-col class="shrink pa-0">
          <v-btn text @click="showSafetyDialog = true">Trykk her</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- <v-fab-transition>
      <v-btn
        v-show="
          $vuetify.breakpoint.mobile &&
          !psiAccepted &&
          showPsiScrollBtn &&
          project.isPsiMissing !== undefined
        "
        class="btnPsiCenter"
        color="pink"
        fixed
        dark
        @click="goToBottom"
      >
        PSI ikke akseptert
        <v-icon rigth>mdi-arrow-down-thin</v-icon>
      </v-btn>
    </v-fab-transition> -->

    <BaseView v-model="list">
      <template v-slot="{ element }">
        <!-- Mobile -->
        <ProjectBuildings
          v-if="element.type === 'ProjectBuildings'"
          :houses="houses"
          @activeHouse="changeActiveHouse"
        />
        <ProjectShortcuts
          v-if="element.type === 'ProjectShortcuts'"
          :projectId="project.id"
          :houseName="activeHouseNumber"
        />
        <ProjectServices v-if="element.type === 'ProjectServices'" />

        <!-- btn project -->
        <div v-if="element.type === 'ProjectButtons' && !houseIsActive">
          <v-btn
            color="primary"
            large
            block
            depressed
            :to="{ name: 'ProjectBlueprints' }"
          >
            <v-icon left>mdi-floor-plan</v-icon>
            Prosjekttegninger
          </v-btn>

          <v-btn
            v-if="isTrysilhus && project.hasBarrack"
            class="mt-4"
            color="primary"
            large
            block
            depressed
            :to="{ name: 'ProjectBookings' }"
          >
            <v-icon left>mdi-calendar-range</v-icon>
            Bookinger
          </v-btn>

          <!-- <v-btn class="mb-4" color="primary" large block depressed>
            <v-icon left>mdi-chart-timeline</v-icon>
            Tidplan
          </v-btn> -->
        </div>

        <!-- btn house -->
        <div v-if="element.type === 'ProjectButtons' && houseIsActive">
          <v-btn
            class="mb-4"
            color="primary"
            large
            block
            depressed
            :to="{ name: 'BuildingBlueprintsView' }"
          >
            <v-icon left>mdi-floor-plan</v-icon>
            Byggtegninger
          </v-btn>

          <v-btn
            v-if="isTrysilhus"
            class="mb-4"
            color="primary"
            large
            block
            depressed
            :to="{ name: 'OrdersView' }"
          >
            <v-icon left>mdi-truck-delivery-outline</v-icon>
            Bestillinger
          </v-btn>

          <v-btn
            class="mb-4"
            color="primary"
            large
            block
            depressed
            @click="optionsDownload"
          >
            <v-icon left>mdi-package-variant</v-icon>
            Tilvalgsliste
          </v-btn>

          <v-btn
            class="mb-4"
            color="primary"
            large
            block
            depressed
            @click="colorDownload"
          >
            <v-icon left>mdi-format-paint</v-icon>
            Fargevalg
          </v-btn>
        </div>

        <!-- Desktop -->
        <ProjectShortcutsDesktop
          v-if="element.type === 'ProjectShortcutsDesktop'"
          :houseIsActive="houseIsActive"
          :hasBarrack="project.hasBarrack"
          @psi="showSafetyDialog = true"
          @optionsDownload="optionsDownload"
          @colorDownload="colorDownload"
        />
        <ProjectBuildingsDesktop
          v-if="element.type === 'ProjectBuildingsDesktop'"
          :houses="houses"
        />

        <DashboardComplaints
          v-if="element.type === 'DashboardComplaints'"
          title="Reklamasjoner"
          icon="mdi-clipboard-alert-outline"
          :isEnquiry="false"
          :projectId="$route.params.id"
          :houseId="$route.params.houseId"
          :houseName="activeHouseNumber"
        />

        <DashboardComplaints
          v-if="element.type === 'DashboardEnquiry'"
          title="Hendvendelser"
          icon="mdi-message-text-outline"
          isEnquiry
          :projectId="$route.params.id"
          :houseId="$route.params.houseId"
          :houseName="activeHouseNumber"
        />

        <DashboardMeasures
          v-if="element.type === 'DashboardMeasures'"
          :projectId="$route.params.id"
          :houseId="$route.params.houseId"
          :houseName="activeHouseNumber"
        />

        <DashboardCheckups
          v-if="element.type === 'ProjectCheckups'"
          :projectId="$route.params.id"
          :houseId="$route.params.houseId"
          :houseName="activeHouseNumber"
        />

        <DashboardChecklists
          v-if="element.type === 'ProjectChecklists' && isTrysilhus"
          :projectId="$route.params.id"
          :houseId="$route.params.houseId"
          :houseName="activeHouseNumber"
        />

        <ProjectButtonShortcuts
          v-if="element.type === 'ProjectButtonShortcuts'"
          :psiAccepted="psiAccepted"
          @psi="showSafetyDialog = true"
        />
      </template>
    </BaseView>

    <SafetyDialog
      v-model="showSafetyDialog"
      :projectId="$route.params.id"
      :isPsiMissing="project.isPsiMissing"
      @confirm="savePsi(true)"
      @close="savePsi(false)"
    />

    <PDFDialog v-model="openPDF" :blob="blob" :fileName="fileName" />

    <ProjectInfoDialog v-model="showProjectInfo" :project="project" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import notifications from "@/helpers/notification";
import projectApi from "@/api/projectApi";
import documentApi from "@/api/documentApi";
import contactpersonApi from "@/api/contactpersonApi";
import { projectObject, projObject } from "@/types/projectInterface";
import { saveFile } from "@/helpers/files";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";

import ProjectBuildings from "@/components/projects/project/children/ProjectBuildings.vue";
import ProjectShortcuts from "@/components/projects/project/children/ProjectShortcuts.vue";
import ProjectServices from "@/components/projects/project/children/ProjectServices.vue";

import DashboardComplaints from "@/components/dashboard/desktop/DashboardComplaints.vue";
import DashboardMeasures from "@/components/dashboard/desktop/DashboardMeasures.vue";
import DashboardCheckups from "@/components/dashboard/desktop/DashboardCheckups.vue";
import DashboardChecklists from "@/components/dashboard/desktop/DashboardChecklists.vue";

import ProjectShortcutsDesktop from "@/components/projects/project/children/desktop/ProjectShortcutsDesktop.vue";
import ProjectBuildingsDesktop from "@/components/projects/project/children/desktop/ProjectBuildings.vue";

import ProjectButtonShortcuts from "@/components/projects/project/children/desktop/ProjectButtonShortcuts.vue";

import SafetyDialog from "@/components/shared/dialog/SafetyDialog.vue";
import PDFDialog from "@/components/shared/dialog/PDFDialog.vue";
import ProjectInfoDialog from "@/components/projects/project/children/ProjectInfoDialog.vue";

export default Vue.extend({
  name: "Dashboard",
  data() {
    return {
      enableFollowing: true,
      showSafetyDialog: false,
      psiAccepted: true,
      showPsiScrollBtn: false,
      psiAgreementKey: "psiAgreement",
      project: {} as projectObject,
      houses: [],
      activeHouse: "",
      image: "",
      blob: null,
      fileName: "",
      openPDF: false,
      showProjectInfo: false,

      list: {
        lg: [
          [
            { type: "ProjectShortcutsDesktop" },
            { type: "ProjectBuildingsDesktop" },
          ],
          [{ type: "DashboardComplaints" }, { type: "DashboardEnquiry" }],
          [
            { type: "DashboardMeasures" },
            { type: "ProjectCheckups" },
            { type: "ProjectChecklists" },
          ],
        ],
        md: [
          [
            { type: "ProjectShortcutsDesktop" },
            { type: "ProjectBuildingsDesktop" },
          ],
          [{ type: "DashboardComplaints" }, { type: "DashboardEnquiry" }],
          [
            { type: "DashboardMeasures" },
            { type: "ProjectCheckups" },
            { type: "ProjectChecklists" },
          ],
        ],
        sm: [
          [
            { type: "ProjectBuildings" },
            { type: "ProjectShortcuts" },
            { type: "ProjectServices" },
            { type: "ProjectButtons" },
          ],
        ],
        xs: [
          [
            { type: "ProjectBuildings" },
            { type: "ProjectShortcuts" },
            { type: "ProjectServices" },
            { type: "ProjectButtons" },
          ],
        ],
      },
    };
  },
  async created() {
    this.fetchData();

    this.$watch(
      () => this.$route.params,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
  },
  watch: {
    async isStartDialogFinished(value, oldValue) {
      if (value) {
        await this.checkPsiStatus();
      }
    },
  },
  mounted() {
    //Hide scroll to Psi btn after x time
    setTimeout(() => {
      this.showPsiScrollBtn = false;
    }, 2500);
  },
  beforeDestroy() {
    this.setHeaderName("");
  },
  methods: {
    ...mapActions({
      setHeaderName: "shared/setHeaderName",
      setLoadingText: "shared/setLoadingText",
    }),
    async fetchData() {
      this.setLoadingText("Vennligst vent.. prosjekt lastes inn");
      var projectId = this.$route.params.id;
      if (projectId) {
        await projectApi
          .getProject(projectId)
          .then((Response) => {
            this.project = Response;
            this.setHeaderName(this.project.name);
            this.getProjectImage(this.project);
          })
          .catch(() => {
            this.$router.push({ name: "Dashboard" });
          });

        await projectApi.getProjectHouses(projectId).then((response) => {
          this.houses = response;
        });

        //Is psi confirmed
        await this.checkPsiStatus();
      }
    },

    async updateFavourite(project) {
      this.enableFollowing = false;
      project.isFavourite = !project.isFavourite;
      await projectApi.updateFavourite(project).then((response) => {
        this.enableFollowing = response;
      });
    },

    async checkPsiStatus() {
      if (this.isStartDialogFinished) {
        // var projectId = this.project?.id;
        var projectId = this.$route.params.id;
        await contactpersonApi
          .getUserSetting(this.psiAgreementKey)
          .then((response) => {
            //Open dialog if not project PSI is not confirmed
            //If project have infotech id and have Psi docuemnt
            if (
              (!response || !response[projectId]) &&
              this.project?.isPsiMissing === false
            ) {
              this.showSafetyDialog = true;
              this.psiAccepted = false;
            } else if (!response[projectId]?.confirm) {
              //Dialog is closed not confirmed
              //Set psi not accepted and show scroll to psi btn
              this.psiAccepted = false;
              this.showPsiScrollBtn = true;
            }
          });
      }
    },
    async savePsi(hasConfirmed: boolean) {
      // if (!this.project.isPsiMissing) {
      var projectId = this.$route.params.id;
      await contactpersonApi
        .getUserSetting(this.psiAgreementKey)
        .then(async (response) => {
          if (!response || !response[projectId]?.confirm) {
            //If first time, then set object
            if (!response) {
              response = {};
            }
            //Add new information
            response[projectId] = {
              date: moment().format(),
              confirm: hasConfirmed,
            };
            //Save all confirmed
            await contactpersonApi.putUserSetting(
              this.psiAgreementKey,
              response,
              false
            );
            this.psiAccepted = hasConfirmed;
            this.showSafetyDialog = false;
          } else {
            notifications.warn("Sikkerhetsinnstruks er allerede godkjent!");
          }
        });
      // } else {
      //   debugger;
      //   this.showSafetyDialog = false;
      // }
    },
    goToBottom() {
      //Hide scroll btn
      this.showPsiScrollBtn = false;
      //Scroll to bottom af page
      this.$vuetify.goTo(document.body.scrollHeight);
    },
    async getProjectImage(projects: projObject) {
      // projects.forEach(async (x) => {
      await projectApi.getProjectImage(projects.id).then((resp) => {
        this.image = "data:" + resp.contentType + ";base64," + resp.image;
      });
      // });
    },
    changeActiveHouse(house) {
      if (house) {
        this.activeHouse = house;
      } else {
        this.activeHouse = "";
      }
    },
    optionsDownload() {
      var houseId = this.$route.params.houseId;

      projectApi.getPhaseoptionsandchanges(houseId, this.isKiosk).then((x) => {
        var extension = this.isKiosk ? ".pdf" : ".xlsx";
        saveFile(
          x,
          `Tilvalg og forandringer ${this.project.name} - Bygg ${this.activeHouseNumber}${extension}`
        );
      });
    },
    colorDownload() {
      var houseId = this.$route.params.houseId;
      projectApi.getColorOptions(houseId).then((x) => {
        saveFile(
          x,
          `Fargevalg ${this.project.name} - Bygg ${this.activeHouseNumber}`
        );
      });
    },
    getAccident() {
      documentApi.getAccidentDocuments(this.project.id).then((response) => {
        this.fileName = `Varslingsplan ${this.project.name}`;
        this.blob = response;
        this.openPDF = true;
      });
    },
    projectInfo() {
      this.showProjectInfo = true;
    },
  },

  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      isStartDialogFinished: "shared/isStartDialogFinished",
      profile: "shared/profile",
      isKiosk: "shared/isKiosk",
      noHMScard: "shared/noHMScard",
    }),
    houseIsActive(): boolean {
      return !!this.$route.params.houseId;
    },
    activeHouseNumber(): string {
      if (this.houseIsActive && this.houses.length > 0) {
        var house = (this as any).houses.find(
          (x) => x.id === parseInt(this.$route.params.houseId)
        );

        return house.houseNum;
      }
      return "";
    },
    getFollowingEnable(): boolean {
      return this.enableFollowing;
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    ProjectBuildings,
    ProjectShortcuts,
    ProjectServices,

    DashboardComplaints,
    DashboardMeasures,
    DashboardCheckups,
    DashboardChecklists,

    ProjectBuildingsDesktop,
    ProjectButtonShortcuts,
    ProjectShortcutsDesktop,
    SafetyDialog,
    PDFDialog,
    ProjectInfoDialog,
  },
});
</script>

<style lang="scss" scoped>
.btnPsiCenter {
  z-index: 2;
  left: 50%;
  bottom: calc(50px + env(safe-area-inset-bottom));
  transform: translate(-50%, -50%);
}

.testImg {
  // background: url("https://thg.blob.core.windows.net/public-images/login_bg.jpg");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;

  opacity: 0.3;
}
</style>
